import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyBoardRapidViewRoute: InvariantJiraRoute = {
	name: 'legacy-board',
	path: '/secure/RapidBoard.jspa',
	query: ['rapidView'],
};
